/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.33333 17C8.59695 17 8 16.403 8 15.6667C8 14.1939 9.19391 13 10.6667 13H13.3333C14.8061 13 16 14.1939 16 15.6667C16 16.403 15.403 17 14.6667 17H9.33333ZM14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11ZM15.3333 18C16.2538 18 17 17.2538 17 16.3333C17 14.4924 15.5076 13 13.6667 13H10.3333C8.49238 13 7 14.4924 7 16.3333C7 17.2538 7.74619 18 8.66667 18H15.3333Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3.33782 7C2.48697 8.47087 2 10.1786 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C10.5778 2 9.22492 2.2969 8 2.83209M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM16 15.6667V15.6667C16 14.1939 14.8061 13 13.3333 13H10.6667C9.19391 13 8 14.1939 8 15.6667V15.6667C8 16.403 8.59695 17 9.33333 17H14.6667C15.403 17 16 16.403 16 15.6667Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M0.75 10.75C0.75 16.2728 5.22715 20.75 10.75 20.75C16.2728 20.75 20.75 16.2728 20.75 10.75C20.75 5.22715 16.2728 0.75 10.75 0.75M0.75 10.75C0.75 5.22715 5.22715 0.75 10.75 0.75M0.75 10.75C0.75 8.92856 1.23697 7.22087 2.08782 5.75M10.75 0.75C9.32779 0.75 7.97492 1.0469 6.75 1.58209M12.75 6.75C12.75 7.85457 11.8546 8.75 10.75 8.75C9.64543 8.75 8.75 7.85457 8.75 6.75C8.75 5.64543 9.64543 4.75 10.75 4.75C11.8546 4.75 12.75 5.64543 12.75 6.75ZM14.75 14.4167C14.75 15.153 14.153 15.75 13.4167 15.75H8.08333C7.34695 15.75 6.75 15.153 6.75 14.4167C6.75 12.9439 7.94391 11.75 9.41667 11.75H12.0833C13.5561 11.75 14.75 12.9439 14.75 14.4167Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
				fill="currentColor"
			/>
			<path
				d="M13.6667 13H10.3333C8.49238 13 7 14.4924 7 16.3333C7 17.2538 7.74619 18 8.66667 18H15.3333C16.2538 18 17 17.2538 17 16.3333C17 14.4924 15.5076 13 13.6667 13Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
